<app-header *ngIf="!hideNavbar"></app-header>
<router-outlet *ngIf="finish"></router-outlet>
<app-save-toast></app-save-toast>
<app-footer *ngIf="!hideNavbar"></app-footer>
<simple-notifications></simple-notifications>


// WEBPACK FOOTER //
// ./src/app/app.component.html